export default "__VITE_ASSET__31866639__"